// extracted by mini-css-extract-plugin
module.exports = {"Landing":"LandingPage_Landing__AU0xR","Image":"LandingPage_Image__1zumB","button":"LandingPage_button__1vqrR"};